/* eslint-disable */
import $ from 'jquery';
import lazy from 'jquery-lazy';
import {
    jarallax,
    jarallaxElement,
    jarallaxVideo
} from 'jarallax';
import 'jquery-lazy';
/* eslint-enable */

export default function () {


    /*function loadAritsts() {
        $(".artist-item").slice(0, 15).show();
        $("#loadMore").on('click', function (e) {
            e.preventDefault();
            $(".artist-item:hidden").slice(0, 6).slideDown();
            if ($(".artist-item:hidden").length === 0) {
                $("#loadMore").fadeOut('slow');
            }
            $('html,body').animate({
                scrollTop: $(this).offset().top
            }, 1500);
        });
        if ($(".artist-item:hidden").length === 0) {
            $("#loadMore").fadeOut('slow');
        }
    }



    loadAritsts();*/

    $('.filter-cat-only').click(function (e) {
        $('#artists-listings-holder').html('');
        e.preventDefault();
        $('.filter-cat-only.active').removeClass("active");
        $(this).addClass("active");
        let catID = $(this).data('categoryid');
        let url = window.location.pathname;
        let sendData = {category: catID};
        $("#loading-image").show();
        $.ajax({
            cache: false,
            type: 'GET',
            url: url,
            data: sendData,
            success: function (res) {
                $("#loading-image").hide();
                $('#artists-listings-holder').html(res);
                $.event.trigger({
                    type: "ajaxLoaded"
                });
                let newUrl = url + '?category=' + catID;
                console.log(sendData, newUrl);
                //window.location = newUrl;
                window.history.pushState(sendData, "", newUrl);
                loadAritsts();
            }
        });

    });

}
